<template>
  <div class="v-search-result-window" :style="styleObject">
    <div class="suggestions-section">
      <SearchResultAccordion v-model="suggestionsModel" heading="Suggestions">
        <div v-if="searchLoading">
          <q-spinner-dots color="primary" size="2em" class="q-mx-auto block"/>
        </div>
        <div v-else>
          <template v-if="suggestionsData.length !== 0">
            <SearchRusultSuggestionItem v-for="(item, index) in suggestionsData.slice(0, 5)" @mouseenter="handleShowProducts('SEARCH_PRODUCT',item)" :key="`suggestionsData-${index}`"
              :label="item?.highlight ? item?.highlight : item?.name" :value="item?.matches" :link="item?.link" />
          </template>
            <div v-else class="q-py-md no-result">No results</div>
        </div>
      </SearchResultAccordion>
      <SearchResultAccordion v-model="productLinesModel" heading="Product Lines">
        <div v-if="searchLoading" class="q-py-md">
          <q-spinner-dots color="primary" size="2em" class="q-mx-auto block"/>
        </div>
        <div v-else>
          <template v-if="productLinesData.length !== 0">
            <SearchRusultSuggestionItem 
              v-for="(item, index) in productLinesData" 
              :key="`productLinesData-${index}`"
              @mouseenter="handleShowProducts('L2_PRODUCT',item)"
              :label="item?.highlight ? item?.highlight : item?.name" 
              :value="item?.matches" 
              :link="item?.link" />
          </template>
          <div v-else class="q-py-md no-result">No results</div>
        </div>
      </SearchResultAccordion>
      <SearchResultAccordion v-model="knowledgeBaseModel" heading="Knowledge Base">
        <div v-if="searchLoading" class="q-py-md">
          <q-spinner-dots color="primary" size="2em" class="q-mx-auto block"/>
        </div>
          <div v-else>
          <template v-if="knowledgeBaseData.length !== 0">
            <template v-for="(item, index) in knowledgeBaseData">
              <SearchRusultSuggestionItem v-if='item.type !== "product"'
              :key="`knowledgeBaseData-${index}`"
              @mouseenter="handleShowProducts('KNOWLEDGE_BASE',item),currentKBaseType=item.type"
              :label="item?.highlight ? item?.highlight : item?.name" 
              :value="item?.matches" 
              :link="item?.link" />
            </template>
          </template>
          <div v-else class="q-py-md no-result">No results</div>
        </div>
      </SearchResultAccordion>
    </div>
    <div class="items-section products_area" v-if="$q.screen.gt.md">
      <!-- {{ productSearchResults }} -->
      <div class="row items-center q-mb-md q-ml-sm">
          <div class="col-8">
              <div>Recommended Products under</div>
              <div class="main_search_title">{{getSearchedString}}</div>
          </div>
          <div class="col-4 text-right">
            <a :href="currentNavigateBtnLink" class="navigateLink">
              <q-btn outline color="primary" class="btn_show_all_products" size="md" :label="navigateBtnLabel" />
            </a>
          </div>
      </div>
      <div v-if="currentShowProducts=='SEARCH_PRODUCT'">
        <MatchingProducts :searchType="currentShowProducts" :products="dropdownProductSearchResults" />
      </div>
      <div v-else-if="currentShowProducts=='L2_PRODUCT'">
        <MatchingProducts :searchType="currentShowProducts" :products="L2productSearchResults" />
      </div>
      <div v-else-if="currentShowProducts=='KNOWLEDGE_BASE'" >
        <!-- <div>knowledge base</div> -->
        <div v-if="searchContentLoader" class="contentLoaderWrap">
            <q-spinner color="primary" size="5em" :thickness="6" />
            <div class="loadingText">Loading Results</div>
        </div>
        <div v-else>
          <KBaseResultsCard :articleSearchResults="KbaseTypewiseResults"></KBaseResultsCard>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
/* eslint-disable */
import { useQuasar } from 'quasar';
import { reactive, ref, defineProps, watch , computed, onMounted} from 'vue';
import SearchResultAccordion from './SearchResultAccordion.vue';
import SearchRusultSuggestionItem from "./SearchRusultSuggestionItem.vue"
import MatchingProducts from "./MatchingProducts.vue"
import { storeToRefs } from 'pinia'
import { useDropdownSearchStore } from '../../stores/dropdown-search-store.js';
import { useSearchStore } from '../../stores/search-store'
import { useFilterStore } from '../../stores/filter-store'
import KBaseResultsCard from '../KBaseResultsCard.vue';

const { buildQField } = useFilterStore();
const dropdownSearchStore = useDropdownSearchStore();
const {dropdownProductSearchResults,searchContentLoader} = storeToRefs(dropdownSearchStore);
const { dropdownSearchProducts,setSearchContentLoader, unsetSearchContentLoader } = dropdownSearchStore;

const searchStore = useSearchStore()
const { 
  dropdownArticleSearchResults,
  dropdownArticlesPerPage,
  isDropDownSearch,
  productSearchResults,
  L2productSearchResults,
  articleSearchResults,
  articlesPerPage,
  articlesStartPage,
  articleMatchCount,
  productMatchCount,
  productsPerPage,
  startPage,
  productL1FeedBack,
  productL2FeedBack,
  productDocumentTypeFeedBack,
  searchLoading,
  searchedString,
} = storeToRefs(searchStore)
const { getProductsBySearchString,getL2ProductResults,searchDropdownArticles,searchArticles, debounce } = searchStore



const props = defineProps({
  searchInputBoxString: String
})
const KbaseTypewiseResults=computed(()=>{
  return dropdownArticleSearchResults.value.filter(item => item.documenttype == currentKBaseType.value);
})
const getSearchedString = computed(()=>{
    return searchStore.searchedString;
  })
const suggestionsData = computed(()=>{ 
  return productL2FeedBack.value.map(item => {
    const fieldName = item.value.replace(/&/g, '%26');
    return {
      name: item.value,
      highlight: `<em class="v-hightlight">${item.value}</em>`,
      matches: item.count,
      link: `/search?q=(or${buildQField(searchedString.value)})&q.parser=structured&fq=(and(term+field%3Dl2_+%27${fieldName}%27))`
    }
  })
});

const productLinesData = computed(()=>{
  return productL1FeedBack.value.map(item => {
    const fieldName = item.value.replace(/&/g, '%26'); 
    return {
      name: item.value,
      highlight: null,
      matches: item.count,
      link: `/search?q=(or${buildQField(searchedString.value)})&q.parser=structured&fq=(and(term+field%3Dl1_+%27${fieldName}%27))`
    }
  });
});

const knowledgeBaseData = computed(()=>{ 
  return productDocumentTypeFeedBack.value.map(item => {
    
    const fieldName = item.value.replace(/&/g, '%26');
    return {
      name: item.value,
      type: item.value,
      highlight: '',
      matches: item.count,
      link: `/search?q=(or${buildQField(searchedString.value)})&q.parser=structured&fq=(term+field%3Ddocumenttype+%27${fieldName}%27)`
    }
  });
});

const $q = useQuasar()
const suggestionsModel = ref(true)
const productLinesModel = ref(true)
const knowledgeBaseModel = ref(true)
const currentShowProducts=ref("SEARCH_PRODUCT"); //SEARCH_PRODUCT, L2_PRODUCT, KNOWLEDGE_BASE
const currentKBaseType=ref("blog"); //blog,resource,catalog
const navigateBtnLabel=ref("Shop All");
const currentNavigateBtnLink=ref("#");



const styleObject = reactive({
  width: `${$q.screen.width - (($q.screen.width * 30) / 100)}px`,
  left: `${($q.screen.width - ($q.screen.width - (($q.screen.width * 30) / 100))) / 2}px`
})
if(currentShowProducts.value == 'SEARCH_PRODUCT'){
  styleObject.width = `${$q.screen.width - (($q.screen.width * 38) / 100)}px`
}
else{
  styleObject.width = `${$q.screen.width - (($q.screen.width * 30) / 100)}px`
}
if ($q.screen.xs) {
  styleObject.width = '100vw'
  styleObject.left = 0
}

const executeGetProducts = async (val) => {
  getProductsBySearchString(val)
}

const handleShowProducts = debounce(async(searchType,currentTab) => {
  currentShowProducts.value=searchType;
  currentNavigateBtnLink.value="#";
  // console.log(currentTab?.link);
  styleObject.width = `${$q.screen.width - (($q.screen.width * 30) / 100)}px`
  if(searchType == 'SEARCH_PRODUCT'){
    styleObject.width = `${$q.screen.width - (($q.screen.width * 38) / 100)}px`
    setSearchContentLoader();
    await dropdownSearchProducts(currentTab?.name);
    unsetSearchContentLoader();
    navigateBtnLabel.value=`Shop All ${currentTab?.name}`
    currentNavigateBtnLink.value=currentTab?.link;
  }
  else if(searchType == 'L2_PRODUCT'){
    setSearchContentLoader();
    await getL2ProductResults(currentTab?.name);
    unsetSearchContentLoader();
    navigateBtnLabel.value=`Shop All ${currentTab?.name}`
    currentNavigateBtnLink.value=currentTab?.link;
  }
  else if(searchType=='KNOWLEDGE_BASE'){
    dropdownArticlesPerPage.value = 10
    setSearchContentLoader();
    await searchDropdownArticles(currentKBaseType.value);
    unsetSearchContentLoader();
    navigateBtnLabel.value="Go to Knowledge Base Results"
    currentNavigateBtnLink.value=currentTab?.link;
  }
},100)

// watch(() => props.searchInputBoxString, (newVal) => {
//   if (newVal.length > 3 && !isDropDownSearch.value)
//     debounce(executeGetProducts(newVal), 600)
// })


</script>

<style lang="scss" scoped>
.v-search-result-window {
  width: 1064px;
  position: absolute;
  background: linear-gradient(270deg, #ffffff 0%, #f1f1f1 60.4%);
  top: 158px;
  z-index: 10;
  display: grid;
  grid-template-columns: 314px auto;
  grid-template-areas: "searchSuggestions searchItems";
  border: 1px solid #d9d9d9;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  @media (max-width: $breakpoint-xs) {
    grid-template-columns: auto;
    grid-template-areas: "searchSuggestions";
    top: 188px;
    height: calc(96vh - 188px);
  }
}

.suggestions-section {
  background: #FFFFFF;
  grid-area: searchSuggestions;
  padding: 12px 12px 16px 12px;
  @media (max-width: $breakpoint-xs) {
    border: 1px solid #d9d9d9;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  }
}

.items-section {
  grid-area: searchItems;
  padding: 16px 16px 0px 18px;
  height: 672px;
  // height:790px;
    overflow-y: scroll;
}

.no-result {
  letter-spacing: 0.5px;
  line-height: 18px;
  color: $apg-dark-grey;
  font-weight: 700;
}
.contentLoaderWrap{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 300px;
    .loadingText{
        font-size: 17px;
        padding: 15px 0px;
    }
}
.navigateLink{
  text-decoration: none;
}
.main_search_title{
    font-size: 19px;
    font-weight: 800;
}
.btn_show_all_products{
    font-weight: 900;
}
</style>
